import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [form, setForm] = useState({ username: '', password: '' });
  const [emailForm, setEmailForm] = useState({ email: '', mot_de_passe: '' });
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [otpStep, setOtpStep] = useState(null); // { session_id, message }
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const err = searchParams.get('error');
    if (err) setError(err);
  }, [searchParams]);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/ent', form);
      if (data.needs_otp) {
        setOtpStep({ session_id: data.session_id, message: data.message });
      } else {
        saveAndRedirect(data);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  const handleEmailSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', emailForm);
      saveAndRedirect(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/ent/verify-otp', {
        session_id: otpStep.session_id,
        otp,
      });
      saveAndRedirect(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Code invalide');
    } finally {
      setLoading(false);
    }
  };

  function saveAndRedirect(data) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('enseignant', JSON.stringify(data.enseignant));
    navigate('/dashboard');
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7f9 0%, #e8f0fe 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>

        <div className="text-center mb-4">
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: '#066ac9', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center', marginBottom: 12
          }}>
            <i className="bi bi-mortarboard-fill text-white" style={{ fontSize: '1.5rem' }}></i>
          </div>
          <h4 className="fw-bold mb-1">Suivi Élèves</h4>
          <p className="text-muted" style={{ fontSize: '0.9rem' }}>Espace enseignant</p>
        </div>

        <div className="card">
          <div className="card-body p-4">

            <div className="d-flex align-items-center gap-2 mb-4">
              <div style={{
                width: 32, height: 32, borderRadius: 8, flexShrink: 0,
                background: otpStep ? '#0f766e' : '#e8611a',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <i className={`bi ${otpStep ? 'bi-envelope-check' : 'bi-shield-check'} text-white`}
                  style={{ fontSize: '0.9rem' }}></i>
              </div>
              <div>
                <div className="fw-semibold" style={{ fontSize: '0.95rem' }}>
                  {otpStep ? 'Vérification en deux étapes' : 'Connexion'}
                </div>
                <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                  {otpStep ? otpStep.message : 'Identifiants monlycee.net'}
                </div>
              </div>
            </div>

            {error && (
              <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '0.875rem' }}>
                <i className="bi bi-exclamation-circle me-2"></i>{error}
              </div>
            )}

            {!otpStep ? (
              <>
                {!showEmailForm ? (
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label fw-medium" style={{ fontSize: '0.875rem' }}>
                        Identifiant ENT
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={form.username}
                        onChange={e => setForm({ ...form, username: e.target.value })}
                        placeholder="prenom.nom"
                        autoComplete="username"
                        autoFocus
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label fw-medium" style={{ fontSize: '0.875rem' }}>
                        Mot de passe ENT
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        value={form.password}
                        onChange={e => setForm({ ...form, password: e.target.value })}
                        placeholder="••••••••"
                        autoComplete="current-password"
                        required
                      />
                    </div>
                    <button type="submit" className="btn w-100 fw-semibold"
                      style={{ background: '#e8611a', color: '#fff' }} disabled={loading}>
                      {loading
                        ? <><span className="spinner-border spinner-border-sm me-2"></span>Connexion...</>
                        : 'Se connecter'}
                    </button>
                    <div className="text-center mt-3">
                      <button type="button" className="btn btn-link p-0"
                        style={{ fontSize: '0.75rem', color: '#94a3b8', textDecoration: 'none' }}
                        onClick={() => { setShowEmailForm(true); setError(''); }}>
                        Connexion par e-mail
                      </button>
                    </div>
                  </form>
                ) : (
                  <form onSubmit={handleEmailSubmit}>
                    <div className="mb-3">
                      <label className="form-label fw-medium" style={{ fontSize: '0.875rem' }}>
                        Adresse e-mail
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={emailForm.email}
                        onChange={e => setEmailForm({ ...emailForm, email: e.target.value })}
                        placeholder="vous@example.fr"
                        autoComplete="email"
                        autoFocus
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label fw-medium" style={{ fontSize: '0.875rem' }}>
                        Mot de passe
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        value={emailForm.password}
                        onChange={e => setEmailForm({ ...emailForm, mot_de_passe: e.target.value })}
                        placeholder="••••••••"
                        autoComplete="current-password"
                        required
                      />
                    </div>
                    <button type="submit" className="btn w-100 fw-semibold"
                      style={{ background: '#066ac9', color: '#fff' }} disabled={loading}>
                      {loading
                        ? <><span className="spinner-border spinner-border-sm me-2"></span>Connexion...</>
                        : 'Se connecter'}
                    </button>
                    <button type="button" className="btn btn-link w-100 mt-2"
                      style={{ fontSize: '0.8rem', color: '#64748b' }}
                      onClick={() => { setShowEmailForm(false); setError(''); }}>
                      ← Retour connexion ENT
                    </button>
                  </form>
                )}
              </>
            ) : (
              <form onSubmit={handleOtpSubmit}>
                <div className="mb-4">
                  <label className="form-label fw-medium" style={{ fontSize: '0.875rem' }}>
                    Code reçu par email
                  </label>
                  <input
                    type="text"
                    className="form-control text-center fw-bold"
                    style={{ fontSize: '1.4rem', letterSpacing: '0.4em' }}
                    value={otp}
                    onChange={e => setOtp(e.target.value.replace(/\s/g, ''))}
                    placeholder="______"
                    autoComplete="one-time-code"
                    autoFocus
                    maxLength={8}
                    required
                  />
                  <div className="form-text">
                    Entrez le code envoyé à votre adresse email académique.
                    <br />
                    <small className="text-muted">Après validation, ce code ne vous sera plus demandé.</small>
                  </div>
                </div>
                <button type="submit" className="btn w-100 fw-semibold"
                  style={{ background: '#0f766e', color: '#fff' }} disabled={loading}>
                  {loading
                    ? <><span className="spinner-border spinner-border-sm me-2"></span>Vérification...</>
                    : 'Valider le code'}
                </button>
                <button type="button" className="btn btn-link w-100 mt-2"
                  style={{ fontSize: '0.8rem', color: '#64748b' }}
                  onClick={() => { setOtpStep(null); setOtp(''); setError(''); }}>
                  ← Recommencer
                </button>
              </form>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}
